"use client";

import { RefreshCw } from "lucide-react";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import { toast } from "sonner";
import {
	type BuildVersionWatch,
	startBuildVersionWatch,
} from "@/lib/build-version";

export const NEW_VERSION_TOAST_ID = "chatadv-nova-versao";

/** O aviso calmo: neutro, fica até a pessoa agir ou fechar, uma vez só. */
function showNewVersionToast(_serverSha: string, reloadNow: () => void) {
	toast("Saiu uma versão nova do ChatADV.", {
		id: NEW_VERSION_TOAST_ID,
		duration: Number.POSITIVE_INFINITY,
		icon: <RefreshCw aria-hidden className="size-5 text-primary" />,
		action: { label: "Atualizar", onClick: reloadNow },
	});
}

/**
 * A aba percebe que saiu uma versão nova do front (Paulo, 11/10/2026) e, na
 * próxima troca de página por dentro, carrega a página de verdade, sem
 * recarregar no meio de vídeo tocando ou de texto digitado. Montado uma vez na
 * raiz. A regra inteira está em `lib/build-version.ts`. O aviso usa o
 * `Toaster` do app (sonner), o mesmo de todos os avisos; o `notifications-2`
 * do React Bits Pro é a mesma pilha de avisos, e um segundo sistema só para
 * este destoaria dos outros.
 */
export function BuildVersionWatcher() {
	const pathname = usePathname();
	const watch = useRef<BuildVersionWatch | null>(null);
	const lastPath = useRef(pathname);

	useEffect(() => {
		const started = startBuildVersionWatch({
			currentSha: process.env.NEXT_PUBLIC_BUILD_SHA,
			notify: showNewVersionToast,
		});
		watch.current = started;
		return () => {
			started.stop();
			watch.current = null;
		};
	}, []);

	useEffect(() => {
		if (pathname === lastPath.current) return;
		lastPath.current = pathname;
		watch.current?.onRouteChange();
	}, [pathname]);

	return null;
}
